import { WidgetsPackagesMain } from '@/widgets/packages';

export const PagesPackagesMain = () => <WidgetsPackagesMain />;
